(function () {
    'ngInject';

    angular.module('app.shared.services').factory('OpenAIService', openAIService);

    function openAIService(blockUI, OpenAIAPIService, MultipleFileUploadService, $window, $mdDialog, $timeout) {
        function textToImage($scope, canvas, apiKey, textTyped) {
            const { bulkEdit, selectedObjectGroup, imageSelected } = $scope;
            const targetObjects = bulkEdit?.enabled
                ? selectedObjectGroup?._objects
                : imageSelected
                ? [imageSelected]
                : [];

            const blockUIMessage = 'Transforming your text to an image 📝✨🎨';
            blockUI.start(blockUIMessage);
            OpenAIAPIService.textToImage(apiKey, textTyped)
                .then((response) => {
                    responseObj = JSON.parse(response);
                    if (!responseObj.error) {
                        var imageB64 = responseObj.data[0].b64_json;
                        if (imageB64) {
                            const img = new Image();
                            img.onload = function () {
                                for (const targetObject of targetObjects) {
                                    targetObject.setElement(img);
                                }
                                canvas.renderAll();
                            };
                            img.onerror = function (e) {
                                console.log(e);
                            };
                            img.crossOrigin = 'Anonymous';
                            img.src = 'data:image/png;base64,' + imageB64;
                        }
                    } else {
                        throw new Error(responseObj.error.message);
                    }

                    console.log('done rendering image in placeholder, removing block UI');
                    //WTF, if I don't wrap the blockUI.stop() in a $scope.$apply it wont work :|
                    $scope.$apply(function () {
                        blockUI.stop();
                    });
                })
                .catch((error) => {
                    $window.rumReportError(error);

                    for (const targetObject of targetObjects) {
                        targetObject.oldCutoutImageFile = null;
                        targetObject.oldRBCOPImageFile = null;
                    }

                    $timeout(() => $scope.$apply());
                    blockUI.stop();

                    $mdDialog.show(
                        $mdDialog
                            .alert()
                            .parent(document.body)
                            .clickOutsideToClose(true)
                            .title('We received an error from OpenAI:')
                            .textContent(error.message)
                            .ok('OK!')
                    );
                });
        }

        async function imageToImage($scope, canvas, username, image) {
            const { bulkEdit, selectedObjectGroup, imageSelected } = $scope;
            const targetObjects = bulkEdit?.enabled
                ? selectedObjectGroup?._objects
                : imageSelected
                ? [imageSelected]
                : [];

            const blockUIMessage = 'Transforming your image 📝✨🎨';
            blockUI.start(blockUIMessage);
            for (const targetObject of targetObjects) {
                const targetObjectConfig = targetObject.imageToImageConfig || {};
                OpenAIAPIService.imageToImageOnBackendServer(username, image, targetObjectConfig)
                    .then((response) => {
                        if (response.error) {
                            throw new Error(response.error.message);
                        }

                        if (response.base64_image) {
                            var imageB64 = response.base64_image;
                            if (imageB64) {
                                const img = new Image();
                                img.onload = function () {
                                    targetObject.setElement(img);
                                    canvas.renderAll();
                                };
                                img.onerror = function (e) {
                                    console.log(e);
                                };
                                img.crossOrigin = 'Anonymous';
                                img.src = 'data:image/png;base64,' + imageB64;
                            }
                        }

                        console.log('done rendering image in placeholder, removing block UI');
                        //WTF, if I don't wrap the blockUI.stop() in a $scope.$apply it wont work :|
                        $scope.$apply(function () {
                            blockUI.stop();
                        });
                    })
                    .catch((error) => {
                        $window.rumReportError(error);

                        for (const targetObject of targetObjects) {
                            targetObject.oldCutoutImageFile = null;
                            targetObject.oldRBCOPImageFile = null;
                        }

                        $timeout(() => $scope.$apply());
                        blockUI.stop();

                        $mdDialog.show(
                            $mdDialog
                                .alert()
                                .parent(document.body)
                                .clickOutsideToClose(true)
                                .title('We received an error from OpenAI:')
                                .htmlContent(error.message)
                                .ok('OK!')
                        );
                    });
            }
        }

        return {
            textToImage,
            imageToImage
        };
    }
})();
